function splitCookies() {
    if (!document.cookie) return []
    return document.cookie.split("; ")
}

export function cookieWithName(name: string): string | undefined {
    return splitCookies().filter(cookie => cookie.indexOf(name) === 0)[0]
}